import './App.css';
import db from './constants/firebase';
import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import CommentIcon from '@material-ui/icons/Comment';
import { useHistory } from "react-router-dom";
import firebase from 'firebase/app';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
  HashRouter as Router,
  Switch,
  Route,
  Link,
  withRouter
} from "react-router-dom";
import Copyright from './Copyright'
import theme from './Themer';
import { ThemeProvider } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import HomeIcon from '@material-ui/icons/Home';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import BasicInformation from './BasicInformation';
import Roster from './Roster';
import Grow from '@material-ui/core/Grow';


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    height: 100,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  root: {
    display: 'center',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  title: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  }
}));

function CheckboxList(props) {
  const currentTheme = theme();
  const classes = useStyles(currentTheme);
  const history = useHistory();
  const [showBasicInformation, setShowBasicInformation] = useState(false);
  const BasicInformationProps = {
    first: props.snap.BasicInformation.first_name ? props.snap.BasicInformation.first_name : "",
    last: props.snap.BasicInformation.last_name ? props.snap.BasicInformation.last_name : "",
    function: setShowBasicInformation
  };
  const [showApplicationFee, setShowApplicationFee] = useState(false);

  const [showTeamLogo, setShowTeamLogo] = useState(false);
  const [showVideoAudition, setShowVideoAudition] = useState(false);

  const [showRoster, setShowRoster] = useState(false);
  const RosterProps = { data: (props.snap.Roster.data ? props.snap.Roster.data : {}) };


  const handleRoute = (event, title) => {
    event.preventDefault();
    console.log(title);
    switch (title) {
      case "Basic Information":
        const state = {
          first: props.snap.BasicInformation.first_name ? props.snap.BasicInformation.first_name : "",
          last: props.snap.BasicInformation.last_name ? props.snap.BasicInformation.last_name : "",
          function: setShowBasicInformation
        };
        // history.push({
        // pathname: '/basicinformation',
        // state
        // });
        setShowBasicInformation(true);
        return;
      case "Application Fee":
        const state2 = { link: (props.snap.ApplicationFee.link ? props.snap.ApplicationFee.link : "") };
        history.push({
          pathname: '/applicationfee',
          state2
        });
        return;
      case "Video Audition":
        const state3 = { link: (props.snap.VideoAudition.link ? props.snap.VideoAudition.link : "") };
        history.push({
          pathname: '/videoaudition',
          state3
        });
        return;
      case "Team Logo":
        const state4 = { link: (props.snap.TeamLogo.link ? props.snap.TeamLogo.link : "") };
        history.push({
          pathname: '/teamlogo',
          state4
        });
        return
      case "Roster":
        console.log(props.snap.Roster.data);
        // const state5 = { data: (props.snap.Roster.data ? props.snap.Roster.data : {}) };
        // history.push({
        //   pathname: '/roster',
        //   state5
        // });
        setShowRoster(true);
        return
      default:
        return;
    }

  };

  function handleChecked(title) {
    switch (title) {
      case "Basic Information":
        return props.snap.BasicInformation.completed;
      case "Application Fee":
        return props.snap.ApplicationFee.completed;
      case "Roster":
        return props.snap.Roster.completed == true;
      case "Team Logo":
        return props.snap.TeamLogo.completed;
      case "Video Audition":
        return props.snap.VideoAudition.completed;
      default:
        return false;
    }
  };

  return (
    <Container component="main" maxWidth="lg">
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className={classes.root}>
        <List className={classes.root}>
          {props.tasks.map((task, index) => {
            const labelId = `checkbox-list-label}`;

            return (
              <ListItem key={task.title} role={undefined} dense button onClick={(e) => handleRoute(e, task.title)}>
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={handleChecked(task.title)}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={`${task.title}`} />
                <ListItemSecondaryAction>
                  <IconButton edge="end" aria-label="comments">
                    <CommentIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
        {showBasicInformation && <Grow in={showBasicInformation}>
          <Box>
            <Divider orientation='vertical' flexItem />
            <BasicInformation props={BasicInformationProps} />
          </Box>
        </Grow>}
        {showRoster && <Grow in={showRoster}>
          <Box>
            <Divider orientation='vertical' flexItem />
            <Roster props={RosterProps} />
          </Box>
        </Grow>}
      </Grid>
    </Container>
  );
}

function Tasks(props) {

  const currentTheme = theme();
  const classes = useStyles(currentTheme);

  const { history } = props;
  const [tasks, setTasks] = useState([])
  const [snap, setSnap] = useState({
    BasicInformation: {
      completed: false
    },
    ApplicationFee: {
      completed: false
    },
    Roster: {
      complete: false
    },
    TeamLogo: {
      completed: false
    },
    VideoAudition: {
      completed: false
    }
  });

  useEffect(() => {
    const overallTasks = []
    const fs = db.firestore()
    var user = firebase.auth().currentUser;
    fs.collection('overallTasks').get()
      .then(snapshot => {
        snapshot.docs.forEach(task => {
          overallTasks.push(task.data())
        })
        setTasks(overallTasks)
      })

    fs.collection("users").doc(user.email).get()
      .then((snapshot) => {
        if (snapshot.exists) {
          setSnap(snapshot.data())
        } else {
          console.log("No data available");
        }
      }).catch((error) => {
        console.error(error);
      })
  }, [])

  const handleSignout = () => {
    firebase.auth().signOut().then(() => {
      history.push("/register");
    }).catch((error) => {
      // An error happened.
    });
  }

  const handleHome = () => {
    history.push("/")
  };

  console.log(tasks);
  return (
    <div className="App">
      <ThemeProvider theme={currentTheme}>
        {
          <Container component="main" maxWidth="lg">
            <CssBaseline />
            <AppBar
              position="fixed"
            >
              <Toolbar>
                <IconButton
                  color="inherit"
                  edge="end"
                  className={classes.menuButton}
                  onClick={handleHome}
                >
                  <HomeIcon />
                </IconButton>
                <Typography variant="h6" noWrap className={classes.title}>
                  <Box textAlign="left">
                    BIB XVI Registration Portal
              </Box>
                </Typography>
                <ButtonGroup variant="contained" color="primary" aria-label="contained primary button group">
                  <Button onClick={handleSignout}>  Logout </Button>
                </ButtonGroup>
              </Toolbar>
            </AppBar>
            <Box p={5} />
            <div className={classes.paper}>
              <Typography variant="h2">
                Tasks
          </Typography>
              <Box p={3} />
              <React.Fragment>
                <CheckboxList tasks={tasks} snap={snap}>
                </CheckboxList>
              </React.Fragment>
            </div>
            <Box mt={8}>
              <Copyright />
            </Box>
          </Container>
        }
      </ThemeProvider>
    </div>
  );
};


export default withRouter(Tasks);
